<template>
  <PageWrapper
    :isLoading="isLoading"
    isDense
    has-filters
    @submitFilters="getBlockedUsersList"
  >
    <template #title> لیست کاربران مسدود شده </template>
    <template #titleBtn>
      <BButton variant="success" @click="renderAddUserToBlocklistDialog">
        افزودن کاربر به لیست مسدودی
      </BButton>
    </template>
    <template #filters>
      <SearchInput
        :inputValue="blockedUsersFilters.searchCommand"
        inputLabel="جستجو بر اساس نام کاربر"
        inputPlaceholder="امیر..."
        v-model="blockedUsersFilters.searchCommand"
        @enter="getBlockedUsersList"
      ></SearchInput>
    </template>
    <CustomTable
      v-if="blockedUsers"
      :pageNumber="blockedUsersFilters.pageNumber"
      :count="blockedUsersFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="blockedUsers"
      @changePage="changePage"
    >
      <template #studentUserName="data">
        <b-link :to="`/master/users/${data.item.userId}`">
          {{ data.item.studentUserName }}
        </b-link>
      </template>
      <template #actions="data">
        <div class="d-flex align-items-center justify-content-center">
          <BButton
            variant="danger"
            size="sm"
            @click="renderUnblockConfirmationModal(data.item)"
          >
            عدم مسدود سازی کاربر
          </BButton>
        </div>
      </template>
    </CustomTable>
    <AddUserToBlocklistDialog
      @refetch="getBlockedUsersList"
    ></AddUserToBlocklistDialog>
    <UnblockConfirmationDialog
      :studentId="tempBlockedUserId"
      @refetch="getBlockedUsersList"
    ></UnblockConfirmationDialog>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getBlockedUsersList();
  },
  data() {
    return {
      isLoading: false,
      tempBlockedUserId: null,
      blockedUsers: null,
      totalCount: null,
      blockedUsersFilters: {
        pageNumber: 1,
        count: 10,
        id: null,
        searchCommand: null,
      },
      tableColumns: [
        {
          key: "userId",
          label: "شناسه",
        },
        {
          key: "studentUserName",
          label: "نام کاربر",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    renderAddUserToBlocklistDialog() {
      this.$bvModal.show("add-user-to-blocklist");
    },
    renderUnblockConfirmationModal(blockedUser) {
      this.tempBlockedUserId = blockedUser.userId;
      this.$bvModal.show("remove-user-from-blocklist");
    },
    changePage(pageNumber) {
      this.blockedUsersFilters.pageNumber = pageNumber;
      this.getBlockedUsersList();
    },
    async getBlockedUsersList() {
      try {
        this.isLoading = true;
        if (getUserData() && getUserData().user && getUserData().user.userId) {
          this.blockedUsersFilters.id = getUserData().user.userId;
        }
        let _this = this;
        let getMasterBlockList = new GetMasterBlockList(_this);
        getMasterBlockList.setRequestParam({
          masterId: _this.masterUserId,
        });
        getMasterBlockList.setRequestParamDataObj(_this.blockedUsersFilters);
        await getMasterBlockList.fetch((res) => {
          _this.blockedUsers = res.data.data;
          _this.totalCount = res.data.count;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BButton,
    PageWrapper,
    CustomTable,
    AddUserToBlocklistDialog,
    UnblockConfirmationDialog,
    SearchInput,
    BLink,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import AddUserToBlocklistDialog from "@/views/components/Block/AddUserToBlocklistDialog.vue";
import UnblockConfirmationDialog from "@/views/components/Block/UnblockConfirmationDialog.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";

import { GetMasterBlockList } from "@/libs/Api/Users";
import { BButton, BLink } from "bootstrap-vue";
import { getUserData } from "@/auth/utils";
</script>
